import 'aframe';
// @ts-ignore
import {Entity} from 'aframe-react';
import React from 'react';
import Community1 from "./images/community1.png"
import Community2 from "./images/community2.jpg"


interface VRSceneProps {
    image: "Community1"|"Community2";
    OnBack: () => void;
}
export function VRScene(props : VRSceneProps) {
    const imgs = {
        Community1: Community1,
        Community2: Community2
    }

    function ExitVr() {
        // @ts-ignore
        document?.querySelector('a-scene')?.exitVR();
    }

        return (
            <>
                <Entity oculus-touch-controls="hand: left"></Entity>
                <Entity oculus-touch-controls="hand: right"></Entity>
                <Entity laser-controls="hand: right"></Entity>
                <Entity primitive="a-sky" radius="100" height="2048" width="4092" src={imgs[props.image]}></Entity>

                <Entity primitive='a-box' color="white" position="3 3 -5" width="2" height="1" depth="1"
                        events={{click: () => props.OnBack()}}>
                    <Entity text="value: Back;color:black;width: 10;" position="4.5 0 0.51" ></Entity>
                </Entity>

                <Entity primitive='a-box' color="white" position="6 3 -5" width="2" height="1" depth="1"
                        events={{click: () => ExitVr()}}>
                    <Entity text="value: Exit;color:black;width: 10;" position="4.5 0 0.51" ></Entity>
                </Entity>
            </>
        );
    }

